import type { CheckoutInterval } from '../../../../shared/schemas/subscription';

const INTERVAL_LABELS: Record<CheckoutInterval, string> = {
  year: 'Annual',
  month: 'Monthly',
};

const DEFAULT_INTERVALS: readonly CheckoutInterval[] = ['year', 'month'];

interface BillingIntervalToggleProps {
  interval: CheckoutInterval;
  onChange?: (interval: CheckoutInterval) => void;
  allowedIntervals?: readonly CheckoutInterval[];
  ariaLabel: string;
}

export function BillingIntervalToggle({
  interval,
  onChange,
  allowedIntervals = DEFAULT_INTERVALS,
  ariaLabel,
}: BillingIntervalToggleProps) {
  const isInteractive = allowedIntervals.length > 1 && onChange != null;

  return (
    <div
      className="inline-flex rounded-standard p-0.5"
      role="group"
      aria-label={ariaLabel}
    >
      {allowedIntervals.map((option) => {
        const isSelected = interval === option;

        return (
          <button
            key={option}
            type="button"
            onClick={isInteractive ? () => onChange(option) : undefined}
            disabled={!isInteractive}
            aria-pressed={isSelected}
            className={`rounded-standard px-3 py-1.5 text-label-sm transition-colors ${
              isSelected
                ? 'bg-surface-frost-08 text-text-primary'
                : 'text-text-tertiary hover:text-text-secondary'
            } ${!isInteractive ? 'cursor-default' : ''}`}
          >
            {INTERVAL_LABELS[option]}
          </button>
        );
      })}
    </div>
  );
}
